<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconCopy_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M6 3h10a3 3 0 0 1 3 3v1h-9a3 3 0 0 0-3 3v9H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3"
        clip-rule="evenodd"
    />
    <rect width="12" height="12" x="9" y="9" fill="currentColor" rx="2" />
</svg>
